import * as React from "react";
import { CardsManagerCallbacks } from "../../CardsManager/CardsManager";
import Feed from "../../Feed/Feed";
import { Switch, Route } from "react-router-dom";
import "./List.css";
import CollectionCard from "../../CollectionCard/CollectionCard";

interface Props {
	callbacks: CardsManagerCallbacks;
}

const List: React.FC<Props> = (props) => {
	return (
		<div className="listPage">
			<Switch>
				<Route path="/list/category-:id">
					<Feed callbacks={props.callbacks} />
				</Route>

				<Route>
					<Feed callbacks={props.callbacks} />

					<div className="listPage-feed__showMore">
						<CollectionCard header="Обновить" action="/list" />
					</div>
				</Route>
			</Switch>
		</div>
	);
};

export default List;
